import { FC } from 'react';
import { Button, ButtonProps } from 'antd';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './CheckBrokenReferencesButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'check-broken-references-button'
);
addTranslations(translations);

export const CheckBrokenReferencesButton: FC<Omit<ButtonProps, 'id'>> = (
  props
) => {
  const { t } = useTranslation();
  return (
    <Button id="check-broken-references" {...props}>
      {t('button.checkBrokenReferences')}
    </Button>
  );
};
